export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/ob-step-3.png?f59b0de41bc6aeccba1217c1a572b233";